import type { FC } from 'react'

import { Modal, Button } from '@/components'


interface T_ModalBecomeShareholderForFullAccessProps {
  open: boolean
  onOk: () => void
}

export const ModalBecomeShareholderForFullAccess: FC<T_ModalBecomeShareholderForFullAccessProps> = ({
  open,
  onOk,
}) => (
  <Modal
    open={open}
    closable={false}
    centered
    footer={
      <Button key='ok' type='primary' block onClick={onOk}>
        Хорошо
      </Button>
    }
  >
    <h3>
      Для доступа к полному функционалу нашего приложения станьте пайщиком
    </h3>
  </Modal>
)
